import { FormItem, InputPhone, type InputPhoneProps } from '@faceup/ui'
import type { FieldValues, UseControllerProps } from 'react-hook-form'
import { useCustomController } from '../hooks'
import type { FormItemWrapperProps } from '../typings'

type PhoneInputProps<T extends FieldValues> = InputPhoneProps &
  UseControllerProps<T> &
  FormItemWrapperProps

export const PhoneInput = <T extends FieldValues>({ country, ...props }: PhoneInputProps<T>) => {
  const {
    formItemProps,
    inputProps: { onChange: fieldOnChange, placeholder, inputProps, value },
  } = useCustomController(props)

  return (
    <FormItem {...formItemProps}>
      <InputPhone
        placeholder={placeholder}
        onChange={fieldOnChange}
        value={value}
        country={country}
        {...inputProps}
        {...props}
      />
    </FormItem>
  )
}
